import { useState } from 'react';
import CompanyUserNav from '@/components/pages/company/CompanyUserNav';
import { Button, Form, Input } from 'antd';
import api from '@/api';
import { API_AUTH_CHECK, PATH_AUTH_SIGNUP } from '@/constants/constant';
import HttpStatus from 'http-status-codes';
import { ErrorMessage } from '@/constants/message';
import { Store } from 'antd/lib/form/interface';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

const CompanyUserRegistrationPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { current: company } = useSelector((state: RootState) => state.company);

  const onFinish = (values: Store) => {
    setLoading(true);
    api
      .post(`/company/${company.base?.id}/user`, 'pcompany.PbCompanyUserCreateRequest', { ...values })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <CompanyUserNav />
      <div className="h-full flex justify-center">
        <div className="w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
          <div>사용자 계정 생성</div>
          <Form onFinish={onFinish} layout="vertical" form={form}>
            <Form.Item
              label="이메일"
              name="email"
              hasFeedback
              validateFirst
              rules={[
                { required: true, message: '이메일을 입력하세요.' },
                { type: 'email', message: '잘못된 이메일 형식입니다.' },
                ({ getFieldError, setFields }) => ({
                  validator: async (rule, value, callback) => {
                    if (value && getFieldError('email').length === 0) {
                      setFields([{ name: 'email', validating: true }]);
                      api
                        .post(API_AUTH_CHECK, 'pauth.PbCheckRequest', { type: 'email', value })
                        .then(() => callback())
                        .catch((e) => {
                          setFields([{ name: 'email', validating: false }]);
                          switch (e.response.status) {
                            case HttpStatus.CONFLICT:
                              setFields([{ name: 'email', errors: [ErrorMessage.auth.email.already] }]);
                              break;
                            default:
                              break;
                          }
                          callback('Already used E-mail');
                        })
                        .finally(() => setFields([{ name: 'email', validating: false }]));
                    } else {
                      callback('aaa');
                    }
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="비밀번호"
              name="password"
              rules={[
                { required: true, message: '비밀번호를 입력하세요.' },
                { min: 6, message: '6자 이상 입력하세요.' },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="이름"
              name="name"
              rules={[
                { required: true, message: '이름을 입력하세요.' },
                { min: 2, message: '2자 이상 입력하세요.' },
                { pattern: /^[가-힣]+$/, message: '한글만 입력할 수 있습니다.' },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="핸드폰번호"
              name="phone1"
              rules={[
                { required: true, message: '핸드폰 번호를 입력하세요.' },
                { pattern: /^01(?:0|1|[6-9])[.-]?(\d{3}|\d{4})[.-]?(\d{4})$/, message: '잘못된 형식입니다.' },
              ]}
            >
              <Input placeholder="-를 제외한 숫자만 입력해주세요." />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading} disabled={loading} style={{ margin: '20px auto' }}>
                회원가입
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CompanyUserRegistrationPage;
